import { useAuth0 } from "@auth0/auth0-react";
import { IconButton } from "@cca/components";
import { Loader } from "@core/components";
import { storageKeys } from "@core/constants";
import { MockAuthService } from "@services";
import { useFlagsStatus } from "@unleash/proxy-client-react";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useLocalStorage } from "react-use";

import { Sidebar } from "./components";

export const SecuredLayout = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  const [collapsed, setSidebarCollapsed] = useLocalStorage<boolean>(
    storageKeys.sidebarCollaped,
    undefined,
  );
  const [returnUrl, , removeReturnUrl] = useLocalStorage<string>(
    storageKeys.returnUrl,
    undefined,
    { raw: true },
  );

  const { flagsReady, flagsError } = useFlagsStatus();

  const toggleSidebarVisibility = () =>
    setSidebarCollapsed(collapsed == null ? false : !collapsed);

  if (flagsError || returnUrl) {
    removeReturnUrl();

    return <Navigate to={returnUrl || "/error"} />;
  }

  if (!flagsReady || isLoading) {
    return <Loader fullScreen />;
  }

  const children = (
    <div className="bg-neutral-lighter relative flex min-h-screen">
      <Sidebar
        collapsed={!!collapsed}
        onClose={() => setSidebarCollapsed(true)}
        onToggle={toggleSidebarVisibility}
      />
      <div className="relative flex min-h-screen w-full flex-col overflow-hidden duration-300">
        <header className="sticky top-0 z-20 flex items-center border-b border-gray-100 bg-white px-1 py-0.5 shadow-xl shadow-gray-300/5 sm:px-3 lg:hidden">
          <IconButton
            aria-label="Toggle sidebar menu"
            color="info"
            data-testid="left-side-menu-icon"
            icon="bars"
            onClick={toggleSidebarVisibility}
          />
          {/* <ActionButtons /> */}
        </header>

        <Suspense
          fallback={
            <div className="flex h-full w-full flex-1 items-center justify-center">
              <Loader />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>

      {!collapsed && (
        <div
          className="fixed inset-0 z-49 bg-black/30 backdrop-blur-sm lg:hidden"
          onClick={toggleSidebarVisibility}
        />
      )}
    </div>
  );

  if (MockAuthService.isEnabled && MockAuthService.isAuthorized) {
    return children;
  }

  return isAuthenticated ? children : null;
};
